<template>
    <div class="ma-7">
        <i class="material-icons" style="font-size: 5rem">
            sentiment_very_dissatisfied
        </i>
        <p>
            این راه به جایی نمیرسد!
            <br />
            به نظر آدرس را اشتباه وارد کرده‌اید.
            <br />
            برای پیدا کردن مسیر درست میتوانید سری به
            <a href="/pay2">صفحه اول </a>
            بزنید.
        </p>
    </div>
</template>

<script>
    export default {
        name: "pageNotFound"
    }
</script>

<style scoped>

</style>